var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "map", attrs: { id: "map" } },
    [
      this.$store.getters["isComparisonModeActive"]
        ? _c("div", {
            staticClass: "divider",
            style: { left: _vm.dividerOffset + "px" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.tooltip
        ? _c("tooltip-component", { attrs: { layer: _vm.tileSetLayer } })
        : _vm._e(),
      _vm._v(" "),
      _vm.$conf.tilesets.layers.length > 0 &&
      _vm.$conf.bordersToggler.enabled === true
        ? _c(
            "button",
            {
              staticClass:
                "button is-dark has-background-black-bis border-toggler",
              attrs: { type: "button", position: "is-bottom-left" },
              on: { click: _vm.toggleBorders },
            },
            [
              _vm.borders
                ? _c("b-icon", {
                    attrs: { id: "layers-outline", icon: "layers-outline" },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.borders
                ? _c("b-icon", {
                    attrs: {
                      id: "layers-off-outline",
                      icon: "layers-off-outline",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.$store.getters["isComparisonModeActive"]
        ? _c("b-slider", {
            staticStyle: {
              width: "100%",
              bottom: "50%",
              "z-index": "10",
              position: "absolute",
            },
            attrs: { id: "comparisonSwipe", step: 0.1, tooltip: false },
            on: { input: _vm.listener },
            model: {
              value: _vm.overlap,
              callback: function ($$v) {
                _vm.overlap = $$v
              },
              expression: "overlap",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }